module.exports = __webpack_public_path__ + "img/w30.463862b1.svg";